import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';

// Tabs
import ProfileTab from "./Tabs/Profile";
// import SecurityTab from "./Tabs/Security";

  const tabContent = [
    {panel: "profile", content: <ProfileTab />},
    {panel: "repairs", content: <ProfileTab />},
    
  ]

const ViewSpecialist = () => {

  const tabs = [
    {label: "Profile", icon: <ContactPageOutlinedIcon fontSize="small" />},
    {label: "Repairs", icon: <ContentCutRoundedIcon fontSize="small" />},
  ];

  return (
    <ViewDetails title="Repair Specialist" identifier="full_name" tabs={tabs} tabContent={tabContent} isProfile={true} url="specialists">

    </ViewDetails>
  )
};

export default ViewSpecialist;